import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineFilterIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M19 2H5a3 3 0 0 0-3 3v1.17a3.001 3.001 0 0 0 .25 1.2v.06a2.81 2.81 0 0 0 .59.86L9 14.41V21a1.0001 1.0001 0 0 0 .47.85c.1591.0986.3428.1506.53.15a.9994.9994 0 0 0 .45-.11l4-2A1.0001 1.0001 0 0 0 15 19v-4.59l6.12-6.12a2.8105 2.8105 0 0 0 .59-.86v-.06a2.9998 2.9998 0 0 0 .29-1.2V5a3 3 0 0 0-3-3Zm-5.71 11.29A1.0003 1.0003 0 0 0 13 14v4.38l-2 1V14a1.0003 1.0003 0 0 0-.29-.71L5.41 8h13.18l-5.3 5.29ZM20 6H4V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v1Z"/>
  </SvgIcon>
}

export default LineFilterIcon
